import { FC } from 'react';
import { Divider } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { Gray_Light_100 } from '@common/styles';
import { VerticalProductCardWithItem } from '@common/product-card';

import { ProductItemCarousel } from '../component/ProductItemCarousel';
import { Title } from '../component/Title';
import { AdReviewRecommendGroup_ad_review_recommend_group_UxGoodsGroup_goods_carousel_component_list } from '../graphql/ad_review_recommend_group_types.2';
import { useAdreviewRecommendGroupService } from '../service/useAdreviewRecommendGroupService';

interface Props {
  is_empty_review: boolean;
  has_divider?: boolean;
}

export const AdContainer: FC<React.PropsWithChildren<Props>> = ({ is_empty_review, has_divider = false }) => {
  const { is_ad, main_title, item_list, onImpressionProduct, onClickProduct, onSavedProduct } =
    useAdreviewRecommendGroupService();

  if (!item_list) {
    return null;
  }

  const is_empty_recommend_group = item_list.length === 0;

  return (
    <>
      <SC.Container is_empty_review={is_empty_review}>
        <ProductItemCarousel
          title={<Title title={main_title?.text ?? ''} isAd={is_ad} />}
          productItemList={item_list}
          renderProductCard={(item, index) => (
            <VerticalProductCardWithItem<AdReviewRecommendGroup_ad_review_recommend_group_UxGoodsGroup_goods_carousel_component_list>
              item={item}
              key={item.catalog_product_id}
              onImpression={(item) => onImpressionProduct(item, index)}
              onClick={(item) => onClickProduct(item, index)}
              onLikeClick={(checked, item) => onSavedProduct(checked, item, index)}
              size='small'
            />
          )}
        />
      </SC.Container>

      {has_divider && !is_empty_recommend_group && <Divider size='8px' spacing='0px' color='dividerBold' />}
    </>
  );
};

const SC = {
  Container: styled.div<{ is_empty_review: boolean }>`
    border-top: ${({ is_empty_review }) => is_empty_review && `8px solid ${Gray_Light_100}`};
    margin-top: ${({ is_empty_review }) => is_empty_review && '100px'};
  `,
};
